<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferQueryAll"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 grey--text">ทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">{{
                  sumconditions_transfer.sum
                }}</v-list-item-title>
              </v-list-item-content>
              <v-avatar size="40" color="info lighten-5"
                ><v-icon color="info">mdi-clipboard-list</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrc"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 success--text">ตรวจสอบแล้ว</div>
                <v-list-item-title
                  class="headline font-weight-bold success--text"
                  >{{ sumconditions_transfer.sumreceive }}</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="success lighten-5"
                ><v-icon color="success">mdi-check-circle</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrcb"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 warning--text">ไม่สมบูรณ์</div>
                <v-list-item-title
                  class="headline font-weight-bold warning--text"
                  >{{
                    sumconditions_transfer.sumreceive_but
                  }}</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="warning lighten-5"
                ><v-icon color="warning darken-2">mdi-alert</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrl"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 error--text">ไม่รับย้าย/ยกเลิก</div>
                <v-list-item-title
                  class="headline font-weight-bold error--text"
                >
                  {{
                    parseInt(sumconditions_transfer.sumrelocated || 0) +
                      parseInt(sumconditions_transfer.sumcc || 0)
                  }}
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="40" color="error lighten-5"
                ><v-icon color="error">mdi-close-circle</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="search_not_submit"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 primary--text">
                  ยังไม่ส่งข้อมูล
                </div>
                <v-list-item-title
                  class="headline font-weight-bold primary--text"
                  >Filter</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="primary lighten-5"
                ><v-icon color="primary"
                  >mdi-account-clock</v-icon
                ></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="search_confirm"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 info--text">รอตรวจสอบ</div>
                <v-list-item-title class="headline font-weight-bold info--text"
                  >Filter</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="info lighten-5"
                ><v-icon color="info">mdi-eye</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="ข้อมูลการย้าย สายการสอนและสายสนับสนุน"
        color="primary"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn
                small
                rounded
                dark
                color="primary darken-1"
                @click="openAddCollegeDialog"
              >
                <v-icon left>mdi-domain-plus</v-icon> เพิ่มสถานศึกษา (แทนสถานศึกษา)
              </v-btn>
              <v-btn
                small
                rounded
                dark
                color="primary"
                :href="reportLinks.conditionAll"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> รายงานเงื่อนไข (รอบปัจจุบัน)
              </v-btn>
              <v-btn
                small
                rounded
                dark
                color="info"
                href="#/admin/print_jor18_teacherMove/"
                target="_blank"
              >
                <v-icon left>mdi-printer-settings</v-icon> เงื่อนไขทั้งหมด
              </v-btn>
              <v-btn
                small
                rounded
                outlined
                color="success"
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    outlined
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-filter-variant</v-icon> ตัวเลือกกรองพิเศษ
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="search_not_submit_but">
                    <v-list-item-icon
                      ><v-icon color="error"
                        >mdi-account-alert</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title
                      >มีตำแหน่งว่างแต่ไม่ดำเนินการ</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="search_documentFile">
                    <v-list-item-icon
                      ><v-icon color="error"
                        >mdi-file-hidden</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title
                      >สถานศึกษาไม่ได้แนบไฟล์</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา (ชื่อวิทยาลัย, รหัส, สถานะ)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="conditions_transfers"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
          :item-class="row_classes"
        >
          <template v-slot:item.college_name="{ item }">
            <div class="font-weight-bold">{{ item.college_name }}</div>
            <div class="caption grey--text">{{ item.college_code }}</div>
          </template>

          <template v-slot:item.branch_count="{ item }">
            <v-chip
              small
              :color="Number(item.branch_count) > 0 ? 'info lighten-5' : 'grey lighten-3'"
              :text-color="Number(item.branch_count) > 0 ? 'info darken-2' : 'grey darken-1'"
              style="cursor: pointer"
              @click="openBranchList(item)"
            >
              <v-icon left x-small>mdi-book-open-variant</v-icon>
              {{ item.branch_count || 0 }} สาขา
            </v-chip>
          </template>

          <template v-slot:item.documentsLinkfile="{ item }">
            <div
              v-if="item.documentsLinkfile"
              class="d-flex align-center justify-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    @click="viewdocumentsLinkfile(item.documentsLinkfile)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <span>ดูไฟล์</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="error"
                    small
                    @click="cancel_condition(item.id_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบไฟล์</span>
              </v-tooltip>
            </div>
            <div v-else class="text-center">
              <v-btn
                small
                outlined
                color="info"
                rounded
                @click="AddConditionFile(item.id_ref)"
              >
                <v-icon left small>mdi-upload</v-icon> แนบไฟล์
              </v-btn>
            </div>
          </template>

          <template v-slot:item.status_confirm="{ item }">
            <div
              class="text-center"
              style="cursor: pointer"
              @click="
                item.status_confirm !== 'cc'
                  ? receive_status(item.id_ref)
                  : null
              "
            >
              <v-chip
                v-if="item.status_confirm === 'receive'"
                color="success"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-check</v-icon> ถูกต้องครบถ้วน
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'receive_but'"
                color="warning"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-alert</v-icon> ไม่สมบูรณ์
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'relocated'"
                color="grey darken-2"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-cancel</v-icon> ไม่รับย้าย
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'dt_receive'"
                color="error"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-close</v-icon> ไม่ได้รับ
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'cc'"
                color="warning darken-3"
                small
                dark
                label
              >
                ยกเลิก
              </v-chip>
              <v-chip v-else color="info" small outlined label>
                รอตรวจสอบ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.cancel_row="{ item }">
            <div class="text-center">
              <span v-if="item.count_idref === '0'" class="caption error--text"
                >ไม่สำเร็จ</span
              >
              <span
                v-else-if="item.action_sub === 'not_submit'"
                class="caption primary--text"
                >ยังไม่ส่ง</span
              >
              <span
                v-else-if="item.action_sub === 'not_submit_but'"
                class="caption warning--text"
                >มีตำแหน่ง/ไม่ส่ง</span
              >
              <v-btn
                v-else
                icon
                color="grey"
                @click="delete_condition(item.id_ref)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selectedItems"
              :value="item.college_code"
              hide-details
              class="mt-0 pt-0"
            ></v-checkbox>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="receive_dialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>ตรวจสอบเอกสารการรับย้าย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="receive_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="subtitle-1 font-weight-bold mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>
            <div class="caption grey--text mb-4">
              Ref: {{ conditions_transfers_select.id_ref }}
            </div>

            <v-alert colored-border border="left" color="primary" elevation="1">
              <v-radio-group
                v-model="conditions_transfers_select.status_confirm"
                hide-details
              >
                <v-radio
                  value="receive"
                  label="ได้รับแล้ว (ถูกต้องสมบูรณ์)"
                  color="success"
                ></v-radio>
                <v-radio
                  value="receive_but"
                  label="ได้รับแล้ว (แต่ไม่สมบูรณ์)"
                  color="warning"
                ></v-radio>
                <v-radio
                  value="dt_receive"
                  label="ไม่ได้รับเอกสาร"
                  color="error"
                ></v-radio>
                <v-radio
                  value="relocated"
                  label="ไม่ประสงค์รับย้าย"
                  color="grey darken-3"
                ></v-radio>
              </v-radio-group>
            </v-alert>

            <v-text-field
              v-model="conditions_transfers_select.comment_s"
              outlined
              label="หมายเหตุ / เอกสารที่ขาด"
              prepend-inner-icon="mdi-comment-text-outline"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="receive_dialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" depressed @click="receive_Submit"
              >บันทึกผล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="receive_cancel_dialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="warning darken-1" dark flat>
            <v-toolbar-title>แก้ไขสถานะการตรวจสอบ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="receive_cancel_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="subtitle-1 font-weight-bold mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>

            <v-alert colored-border border="left" color="warning" elevation="1">
              <v-radio-group
                v-model="conditions_transfers_select.status_confirm"
              >
                <v-radio
                  value="receive"
                  label="ได้รับแล้ว (ถูกต้องสมบูรณ์)"
                ></v-radio>
                <v-radio
                  value="receive_but"
                  label="ได้รับแล้ว (แต่ไม่สมบูรณ์)"
                ></v-radio>
                <v-radio value="dt_receive" label="ไม่ได้รับเอกสาร"></v-radio>
                <v-radio value="relocated" label="ไม่ประสงค์รับย้าย"></v-radio>
              </v-radio-group>
            </v-alert>

            <v-text-field
              v-model="conditions_transfers_select.comment_s"
              outlined
              label="หมายเหตุแก้ไข"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="receive_cancel_dialog = false">ยกเลิก</v-btn>
            <v-btn color="warning" depressed @click="receive_cancel_Submit"
              >บันทึกการแก้ไข</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Add College (create conditions_transfer record on behalf of a college) -->
      <v-dialog v-model="addCollegeDialog" persistent max-width="500px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary darken-1" dark flat>
            <v-toolbar-title>เพิ่มสถานศึกษา (แทนสถานศึกษา)</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="addCollegeDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <div class="caption grey--text mb-4">
              ใช้เมื่อสถานศึกษาหมดเวลาทำการแล้วแต่ยังไม่ได้แจ้งเงื่อนไขรับย้ายในรอบนี้เลย —
              เมื่อเพิ่มแล้วจะสามารถกดจัดการสาขาวิชาและแนบไฟล์ให้สถานศึกษานี้ต่อได้ทันที
            </div>
            <v-form ref="addCollegeForm" lazy-validation>
              <v-autocomplete
                v-model="newCollegeCode"
                :items="availableColleges"
                item-text="college_name"
                item-value="college_code"
                label="เลือกสถานศึกษา"
                prepend-inner-icon="mdi-school"
                outlined
                dense
                required
                :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
              ></v-autocomplete>
              <div class="caption grey--text">
                รอบปัจจุบัน: {{ period_colleges.period_college_times }}/{{
                  period_colleges.period_college_year
                }}
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="addCollegeDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary darken-1" dark depressed @click="addCollegeSubmit">
              <v-icon left>mdi-content-save</v-icon> บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Branch List / Admin-on-behalf-of-college branch condition management -->
      <v-dialog v-model="branchListDialog" scrollable max-width="900px">
        <v-card class="rounded-lg">
          <v-toolbar color="info darken-1" dark flat>
            <div>
              <v-toolbar-title>สาขาวิชาที่แจ้งรับย้าย</v-toolbar-title>
              <div class="caption">
                {{ conditions_transfers_select.college_name }} ({{
                  conditions_transfers_select.college_code
                }})
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="branchListDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-4" style="max-height: 70vh;">
            <div class="text-right mb-2">
              <v-btn
                v-if="!addBranchFormOpen"
                small
                rounded
                color="success"
                @click="openAddBranchForm"
              >
                <v-icon left small>mdi-plus-circle</v-icon> เพิ่มสาขาวิชา
                (แทนสถานศึกษา)
              </v-btn>
            </div>

            <v-data-table
              :headers="branchHeaders"
              :items="branchListItems"
              :loading="branchListLoading"
              dense
              disable-pagination
              hide-default-footer
              class="mb-4"
            >
              <template v-slot:item.name_branch="{ item }">
                {{ item.id_branch }} : {{ item.name_branch }}
              </template>
              <template v-slot:item.Order_file="{ item }">
                <v-btn
                  v-if="item.Order_file"
                  icon
                  small
                  color="info"
                  :href="'/HRvecfiles/' + item.Order_file"
                  target="_blank"
                >
                  <v-icon small>mdi-file-document-outline</v-icon>
                </v-btn>
                <span v-else class="caption grey--text">-</span>
              </template>
              <template v-slot:item.delete_action="{ item }">
                <v-btn icon small color="error" @click="confirmDeleteBranch(item)">
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <div class="pa-4 grey--text">ยังไม่มีสาขาวิชาที่แจ้งไว้</div>
              </template>
            </v-data-table>

            <v-expand-transition>
              <v-card v-if="addBranchFormOpen" outlined class="pa-4 grey lighten-5">
                <v-form ref="addBranchForm" lazy-validation>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="adconditions_branch.id_branch"
                        :items="branch_s"
                        item-text="name_branch"
                        item-value="id_branch"
                        label="สาขาวิชาเอก"
                        prepend-inner-icon="mdi-book-open-variant"
                        outlined
                        rounded
                        dense
                        required
                        :rules="[v => !!v || 'กรุณาเลือกสาขา']"
                        @change="branch_sub_dQueryAll"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="adconditions_branch.con_id_branch_sub"
                        :items="branch_sub_ds"
                        item-text="name_sub_branch"
                        item-value="id_branch_sub"
                        label="สาขางานย่อย"
                        outlined
                        rounded
                        dense
                        required
                        :rules="[v => !!v || 'กรุณาเลือกสาขางาน']"
                        :disabled="!adconditions_branch.id_branch"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        type="number"
                        label="จำนวนรับ (คน)"
                        v-model="adconditions_branch.quantity_n"
                        prepend-inner-icon="mdi-account-plus"
                        outlined
                        rounded
                        dense
                        required
                        :rules="[v => !!v || 'ระบุจำนวน']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        :items="education_s"
                        item-text="title"
                        item-value="title"
                        label="ระดับการศึกษา"
                        v-model="adconditions_branch.educational_level"
                        outlined
                        rounded
                        dense
                        required
                        :rules="[v => !!v || 'เลือกระดับการศึกษา']"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="รายละเอียดคุณลักษณะ (เพิ่มเติม)"
                        v-model="adconditions_branch.con_datail_branch"
                        outlined
                        rounded
                        dense
                        required
                        :rules="[v => !!v || 'ระบุรายละเอียด']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        v-model="Order_file"
                        accept=".pdf"
                        label="แนบไฟล์คำสั่ง/เอกสาร (.pdf)"
                        prepend-icon="mdi-paperclip"
                        outlined
                        rounded
                        dense
                        :rules="branchFileRules"
                        show-size
                        small-chips
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12">
                      <v-divider class="mb-4"></v-divider>
                      <div class="subtitle-2 error--text mb-2">
                        * ระบบความปลอดภัย (Admin ทำรายการแทนสถานศึกษา)
                      </div>
                      <v-text-field
                        label="รหัสผ่านยืนยัน (Admin Password)"
                        v-model="adconditions_branch.secret"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        outlined
                        rounded
                        dense
                        @click:append="show1 = !show1"
                        required
                        :rules="[v => v == '0612698358' || 'รหัสผ่านไม่ถูกต้อง']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-card-actions class="justify-end">
                  <v-btn text @click="addBranchFormOpen = false">ยกเลิก</v-btn>
                  <v-btn
                    color="success"
                    depressed
                    @click="addConditionBranchSubmit"
                  >
                    <v-icon left>mdi-content-save</v-icon> บันทึกสาขาวิชา
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="branchDeleteConfirmDialog" persistent max-width="420px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ยืนยันลบสาขาวิชา
          </v-card-title>
          <v-card-text>
            <v-alert dense outlined color="grey darken-1" class="caption">
              {{ branchToDelete.name_branch }} : {{ branchToDelete.name_sub_branch }}
            </v-alert>
            <v-text-field
              label="Admin Password"
              v-model="branchDeletePassword"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="branchDeleteConfirmDialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="deleteBranchConditionSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="Filecondition_transfer_dialog"
        persistent
        max-width="500px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="info" dark flat>
            <v-toolbar-title>แนบไฟล์เอกสาร (Admin Mode)</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="Filecondition_transfer_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <div class="mb-4">{{ conditions_transfers_File.college_name }}</div>
            <v-file-input
              v-model="documentsLinkfile"
              accept=".pdf"
              label="เลือกไฟล์ PDF"
              outlined
              dense
              show-size
              prepend-icon="mdi-file-pdf-box"
            ></v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="Filecondition_transfer_dialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="success" depressed @click="FileconditionSubmit"
              >อัปโหลด</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deletecondition_transfer_dialog"
        persistent
        max-width="450px"
      >
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ยืนยันลบไฟล์แนบ
          </v-card-title>
          <v-card-text>
            <div class="body-1 mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>
            <v-form ref="deleteconditions_transer_form" lazy-validation>
              <v-text-field
                label="Admin Password"
                v-model="conditions_transfers_select.password_b"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                dense
                required
                :rules="[v => v == '0612698358' || 'รหัสผ่านผิด']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="deletecondition_transfer_dialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="error"
              depressed
              @click="delete_conditions_transfer_Submit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteconditiondialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-forever</v-icon>
            ลบรายการทั้งวิทยาลัย
          </v-card-title>
          <v-card-text>
            <div class="body-1 mb-2">
              ข้อมูลของ:
              {{
                conditions_transfers_select.college_name
              }}
              จะถูกลบทั้งหมดเพื่อให้สถานศึกษาดำเนินการใหม่
            </div>
            <v-form ref="deleteconditionsform" lazy-validation>
              <v-text-field
                label="Admin Password"
                v-model="conditions_transfers_select.password_b"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                dense
                required
                :rules="[v => v == '0612698358' || 'รหัสผ่านผิด']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="deleteconditiondialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="deleteconditionSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="pdfdocumentsLinkfileDialog"
        max-width="90%"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="pdfdocumentsLinkfileDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-toolbar-title>เอกสารแนบ</v-toolbar-title>
          </v-toolbar>
          <div style="height: 100vh;">
            <embed
              :src="'https://hrvec.ovec.go.th/HRvecfiles/' + pdf_files"
              width="100%"
              height="100%"
            />
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องรัน npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      search: "",
      show1: false,
      selectedItems: [],

      // Dialog State
      receive_dialog: false,
      receive_cancel_dialog: false,
      deletecondition_transfer_dialog: false,
      deleteconditiondialog: false,
      Filecondition_transfer_dialog: false,
      pdfdocumentsLinkfileDialog: false,
      branchListDialog: false,
      branchDeleteConfirmDialog: false,
      addCollegeDialog: false,

      // Data
      conditions_transfers: [],
      conditions_transfers_select: {},
      conditions_transfers_File: {},
      updateFileconditions: {},

      // Add college (สร้างรายการ conditions_transfer แทนสถานศึกษา)
      colleges: [],
      newCollegeCode: null,

      // Branch condition management (Admin ทำรายการแทนสถานศึกษา)
      branchListLoading: false,
      branchListItems: [],
      addBranchFormOpen: false,
      adconditions_branch: {},
      branchToDelete: {},
      branchDeletePassword: "",
      Order_file: null,
      branch_s: [],
      branch_sub_ds: [],
      education_s: [
        { title: "ปริญญาตรี" },
        { title: "ปริญญาโท" },
        { title: "ปริญญาเอก" }
      ],
      branchFileRules: [v => !v || v.size < 1048576 || "ไฟล์ต้องไม่เกิน 1 MB"],
      branchHeaders: [
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        { text: "รายละเอียด", align: "left", value: "con_datail_branch" },
        { text: "วุฒิ", align: "center", value: "educational_level" },
        { text: "รับ (คน)", align: "center", value: "quantity_n" },
        { text: "ไฟล์แนบ", align: "center", value: "Order_file", sortable: false },
        { text: "ลบ", align: "center", value: "delete_action", sortable: false }
      ],
      sumconditions_transfer: {
        sum: 0,
        sumcc: 0,
        sumreceive: 0,
        sumreceive_but: 0,
        sumrelocated: 0,
        sumdocpvcfile: 0
      },
      period_colleges: {},
      documentsLinkfile: null,
      pdf_files: null,

      snackbar: { show: false, color: "", icon: "", text: "" },
      headers: [
        { text: "เลือก", value: "select_item", sortable: false },
        { text: "รหัส", align: "center", value: "college_code" },
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "วันที่ส่ง", align: "center", value: "date_time" },
        { text: "อัตราว่าง", align: "center", value: "man_power_college" },
        { text: "สาขาวิชาที่แจ้ง", align: "center", value: "branch_count" },
        { text: "ไฟล์แนบ", align: "center", value: "documentsLinkfile" },
        { text: "สถานะตรวจสอบ", align: "center", value: "status_confirm" },
        {
          text: "ดำเนินการ",
          align: "center",
          value: "cancel_row",
          sortable: false
        }
      ]
    };
  },

  computed: {
    reportLinks() {
      const {
        period_college_times,
        period_college_year
      } = this.period_colleges;
      return {
        conditionAll: `#/admin/print_report_condition_all/${period_college_times}/${period_college_year}`
      };
    },
    availableColleges() {
      const existing = new Set(
        this.conditions_transfers.map(v => v.college_code)
      );
      return this.colleges.filter(c => !existing.has(c.college_code));
    }
  },

  async mounted() {
    await this.period_collegeQuery();
    await this.conditions_transferQueryAll();
  },

  methods: {
    // --- Data Fetching & Core Logic ---
    async period_collegeQuery() {
      let res = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "401"
      });
      this.period_colleges = res.data;
    },

    async conditions_transferQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("conditions_transfer_admin.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year
        });
        this.conditions_transfers = res.data;
        this.calculateStats();
      } finally {
        this.loading = false;
      }
    },

    calculateStats() {
      let stats = {
        sum: 0,
        sumcc: 0,
        sumreceive: 0,
        sumreceive_but: 0,
        sumrelocated: 0,
        sumdocpvcfile: 0
      };
      this.conditions_transfers.forEach(v => {
        stats.sum++;
        if (v.documentsLinkfile) stats.sumdocpvcfile++;
        if (v.status_confirm === "cc") stats.sumcc++;
        if (v.status_confirm === "receive") stats.sumreceive++;
        if (v.status_confirm === "receive_but") stats.sumreceive_but++;
        if (v.status_confirm === "relocated") stats.sumrelocated++;
      });
      this.sumconditions_transfer = stats;
    },

    // --- Add College (สร้างรายการ conditions_transfer แทนสถานศึกษา) ---
    async openAddCollegeDialog() {
      this.newCollegeCode = null;
      if (!this.colleges.length) {
        let res = await this.$http.post("college.php", { ApiKey: this.ApiKey });
        this.colleges = res.data;
      }
      this.addCollegeDialog = true;
    },

    thaiDateToday() {
      const monthNames = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear() + 543;
      return `${dd} ${monthNames[mm]} ${yyyy}`;
    },

    async addCollegeSubmit() {
      if (!this.$refs.addCollegeForm.validate()) return;
      try {
        let idRef =
          this.period_colleges.period_college_times +
          this.period_colleges.period_college_year +
          this.newCollegeCode;

        let res = await this.$http.post("conditions_transfer.insert.php", {
          ApiKey: this.ApiKey,
          id_ref: idRef,
          college_code: this.newCollegeCode,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year,
          date_time: this.thaiDateToday()
        });

        if (res.data.status) {
          this.showSnackbar("เพิ่มสถานศึกษาเรียบร้อย", "success");
          this.addCollegeDialog = false;
          await this.conditions_transferQueryAll();
          // เปิด Dialog จัดการสาขาวิชาต่อทันที เพื่อให้แอดมินทำรายการแทนสถานศึกษาต่อได้ในขั้นตอนเดียว
          let newRow = this.conditions_transfers.find(
            v => v.id_ref === idRef
          );
          if (newRow) {
            await this.openBranchList(newRow);
          }
        } else {
          this.showSnackbar(
            res.data.message || "เพิ่มสถานศึกษาไม่สำเร็จ",
            "error"
          );
        }
      } catch (e) {
        this.showSnackbar("เกิดข้อผิดพลาดในการเพิ่มสถานศึกษา", "error");
      }
    },

    // --- Branch Condition Management (Admin ทำรายการแทนสถานศึกษา) ---
    async openBranchList(item) {
      this.conditions_transfers_select = item;
      this.addBranchFormOpen = false;
      this.adconditions_branch = {};
      this.Order_file = null;
      this.branchListDialog = true;
      await this.loadBranchList();
    },

    async loadBranchList() {
      this.branchListLoading = true;
      try {
        let res = await this.$http.post("conditions_transfer.php", {
          ApiKey: this.ApiKey,
          id_ref: this.conditions_transfers_select.id_ref,
          branch_list: "1"
        });
        this.branchListItems = res.data || [];
      } finally {
        this.branchListLoading = false;
      }
    },

    async openAddBranchForm() {
      this.addBranchFormOpen = true;
      this.adconditions_branch = {};
      this.Order_file = null;
      this.branch_sub_ds = [];
      if (!this.branch_s.length) {
        let res = await this.$http.post("branch.php", { ApiKey: this.ApiKey });
        this.branch_s = res.data;
      }
    },

    async branch_sub_dQueryAll() {
      if (!this.adconditions_branch.id_branch) return;
      let res = await this.$http.post("branch_sub_d.php", {
        ApiKey: this.ApiKey,
        id_main_branch: this.adconditions_branch.id_branch
      });
      this.branch_sub_ds = res.data;
    },

    async addConditionBranchSubmit() {
      if (!this.$refs.addBranchForm.validate()) return;
      this.loading = true;
      try {
        this.adconditions_branch.id_ref = this.conditions_transfers_select.id_ref;
        this.adconditions_branch.college_code = this.conditions_transfers_select.college_code;
        this.adconditions_branch.ApiKey = this.ApiKey;
        this.adconditions_branch.condStatus = "save";

        if (this.Order_file) {
          let formData = new FormData();
          let filename = `${this.conditions_transfers_select.college_code}${Date.now()}CBEdit.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.Order_file);
          formData.append("filename", "../HRvecfiles/" + filename);
          let uploadRes = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          if (uploadRes.data.status) {
            this.adconditions_branch.Order_file = filename;
          }
        }

        let res = await this.$http.post(
          "conditions_branch.insert.php",
          this.adconditions_branch
        );
        if (res.data.status) {
          this.showSnackbar("บันทึกสาขาวิชาเรียบร้อย", "success");
          this.addBranchFormOpen = false;
          await this.loadBranchList();
          await this.conditions_transferQueryAll();
        } else {
          this.showSnackbar(res.data.message || "บันทึกไม่สำเร็จ", "error");
        }
      } catch (e) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.loading = false;
      }
    },

    confirmDeleteBranch(item) {
      this.branchToDelete = item;
      this.branchDeletePassword = "";
      this.branchDeleteConfirmDialog = true;
    },

    async deleteBranchConditionSubmit() {
      if (this.branchDeletePassword !== "0612698358") {
        this.showSnackbar("รหัสผ่านไม่ถูกต้อง", "error");
        return;
      }
      let res = await this.$http.post("conditions_branch.delete.php", {
        ApiKey: this.ApiKey,
        id_ref: this.branchToDelete.id_ref,
        id_branch: this.branchToDelete.id_branch,
        con_id_branch_sub: this.branchToDelete.con_id_branch_sub,
        educational_level: this.branchToDelete.educational_level
      });
      if (res.data.status) {
        this.showSnackbar("ลบสาขาวิชาเรียบร้อย", "success");
        this.branchDeleteConfirmDialog = false;
        await this.loadBranchList();
        await this.conditions_transferQueryAll();
      } else {
        this.showSnackbar("ลบไม่สำเร็จ", "error");
      }
    },

    // --- Filters (API Based) ---
    async fetchWithFilter(params) {
      this.loading = true;
      try {
        let res = await this.$http.post("conditions_transfer_admin.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year,
          ...params
        });
        this.conditions_transfers = res.data;
      } finally {
        this.loading = false;
      }
    },

    conditions_transferStatusrc() {
      this.fetchWithFilter({ status_confirm: "receive" });
    },
    conditions_transferStatusrcb() {
      this.fetchWithFilter({ status_confirm: "receive_but" });
    },
    conditions_transferStatusrl() {
      this.fetchWithFilter({ status_confirm: "relocated" });
    }, // Note: original code might separate 'relocated' and 'cc', check logic if needed combined
    search_not_submit() {
      this.fetchWithFilter({ check_not_submit: "ok" });
    },
    search_not_submit_but() {
      this.fetchWithFilter({ check_not_submit_but: "ok" });
    },
    search_documentFile() {
      this.fetchWithFilter({ check_documentFile: "ok" });
    },

    // Local Filter Logic for "Waiting for Verify"
    search_confirm() {
      this.conditions_transfers = this.conditions_transfers.filter(v => {
        const hasDoc = String(v.documentsLinkfile).length > 5;
        const notVerified = !["relocated", "receive_but", "receive"].includes(
          v.status_confirm
        );
        return hasDoc && notVerified;
      });
    },

    // --- Excel Export ---
    exportToExcel() {
      const data = this.conditions_transfers.map(item => ({
        รหัสสถานศึกษา: item.college_code,
        ชื่อสถานศึกษา: item.college_name,
        วันที่ส่ง: item.date_time || "ยังไม่ส่ง",
        อัตราว่าง: item.man_power_college,
        สถานะ: this.getStatusText(item.status_confirm),
        หมายเหตุ: item.comment_s || ""
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Transfer_Conditions");
      XLSX.writeFile(wb, `Condition_Report_${Date.now()}.xlsx`);
    },

    getStatusText(status) {
      const map = {
        receive: "ถูกต้อง",
        receive_but: "ไม่สมบูรณ์",
        relocated: "ไม่รับย้าย",
        dt_receive: "ไม่ได้รับเอกสาร",
        cc: "ยกเลิก"
      };
      return map[status] || "รอตรวจสอบ";
    },

    // --- Actions (Receive/Delete/File) ---
    async receive_status(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.receive_dialog = true;
    },

    async receive_Submit() {      
        await this.updateStatus(
          "conditions_transfer.update.php",
          this.conditions_transfers_select,
          "บันทึกสถานะเรียบร้อย"
        );
        this.receive_dialog = false;
      
    },

    async receive_cancel_Submit() {
      await this.updateStatus(
        "conditions_transfer.update.php",
        this.conditions_transfers_select,
        "แก้ไขสถานะเรียบร้อย"
      );
      this.receive_cancel_dialog = false;
    },

    async updateStatus(endpoint, payload, successMsg) {
      payload.ApiKey = this.ApiKey;
      let res = await this.$http.post(endpoint, payload);
      if (res.data.status) {
        this.showSnackbar(successMsg, "success");
        await this.conditions_transferQueryAll();
      } else {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    async cancel_condition(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.conditions_transfers_select.password_b = ""; // Clear password
      this.deletecondition_transfer_dialog = true;
    },

    async delete_conditions_transfer_Submit() {
      if (this.$refs.deleteconditions_transer_form.validate()) {
        this.conditions_transfers_select.ApiKey = this.ApiKey;
        // 1. Update Record
        let res = await this.$http.post(
          "conditions_transfer.admin.update.php",
          this.conditions_transfers_select
        );
        // 2. Delete File
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename:
            "../HRvecfiles/" +
            this.conditions_transfers_select.documentsLinkfile
        });

        if (res.data.status) {
          this.showSnackbar("ลบไฟล์เรียบร้อย", "success");
          await this.conditions_transferQueryAll();
        }
        this.deletecondition_transfer_dialog = false;
      }
    },

    async delete_condition(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.conditions_transfers_select.password_b = "";
      this.deleteconditiondialog = true;
    },

    async deleteconditionSubmit() {
      if (this.$refs.deleteconditionsform.validate()) {
        this.conditions_transfers_select.ApiKey = this.ApiKey;
        let res = await this.$http.post(
          "conditions_transfer.delete.php",
          this.conditions_transfers_select
        );
        // Try deleting file too just in case
        if (this.conditions_transfers_select.documentsLinkfile) {
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.conditions_transfers_select.documentsLinkfile
          });
        }

        if (res.data.status) {
          this.showSnackbar("ลบข้อมูลสถานศึกษาเรียบร้อย", "success");
          await this.conditions_transferQueryAll();
        }
        this.deleteconditiondialog = false;
      }
    },

    // --- File Handling ---
    async AddConditionFile(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_File = res.data;
      this.documentsLinkfile = null;
      this.Filecondition_transfer_dialog = true;
    },

    async FileconditionSubmit() {
      if (this.documentsLinkfile) {
        let formData = new FormData();
        let filename = this.conditions_transfers_File.id_ref + "condition.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfile);
        formData.append("filename", "../HRvecfiles/" + filename);

        let uploadRes = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (uploadRes.data.status) {
          this.updateFileconditions = {
            ApiKey: this.ApiKey,
            id_ref: this.conditions_transfers_File.id_ref,
            documentsLinkfile: filename
          };
          await this.updateStatus(
            "conditions_transfer.update.php",
            this.updateFileconditions,
            "อัปโหลดเรียบร้อย"
          );
          this.Filecondition_transfer_dialog = false;
        } else {
          this.showSnackbar("อัปโหลดไม่สำเร็จ", "error");
        }
      }
    },

    viewdocumentsLinkfile(file) {
      this.pdf_files = file;
      this.pdfdocumentsLinkfileDialog = true;
    },

    row_classes(item) {
      return item.status_confirm === "cc" ? "yellow lighten-5" : "";
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f5f5f5;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.2s, box-shadow 0.2s;
}
.shadow-sm:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
